<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-2 pt-2">
        <!-- <div [innerHTML]="'privacy-page-title' | translate | safeHtml"></div> -->
        <div [innerHTML]="'privacy-page-par-1' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-2' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-3' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-4' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-5' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-6' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-7' | translate | safeHtml"></div>
        <div [innerHTML]="'privacy-page-par-8' | translate | safeHtml"></div>
      </div>
    </div>
  </div>
</section>
